export default class BookmakerLinkModel {
  public appType: string = null;
  public selectionTemplateUrl: string = null;
  public eventTemplateUrl: string = null;
  public homepageUrl: string = null;
}
